import type { SmeCompany } from '@/types';
import { getSme, putSme } from '@/utils/request';
import { defineStore } from 'pinia';
import { uploadImages } from '@/utils/upload';
import { ref } from 'vue';

export const useSmeCompaniesStore = defineStore('sme-companies', () => {
  const companies = ref<SmeCompany[]>([]);
  const company = ref<SmeCompany | null>(null);

  const getCompanies = async (): Promise<SmeCompany[]> => {
    const data = await getSme('/companies');
    companies.value = data;
    return data;
  };

  const getCompany = async (id: string): Promise<SmeCompany> => {
    const data = await getSme(`/companies/${id}`);
    company.value = data;
    return data;
  };

  const doUpdateCompanyDetails = async (form: any) => {
    const { files } = form;
    if (files && files.length > 0) {
      await uploadImages(files, 'company_id', form.id, '/companies/logo/upload', true);
    }

    console.log('Update form', form);

    const company = await putSme(`/companies/${form.id}`, form);

    console.log('Updated company', company);

    return company;
  };

  return {
    companies,
    company,
    getCompanies,
    getCompany,
    doUpdateCompanyDetails,
  };
});
